module.exports = __webpack_public_path__ + "static/img/meet-the-team_1.1d24999.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/meet-the-team_1.png
// module id = 9jfo
// module chunks = 0